module.exports = __webpack_public_path__ + "img/azby.432a111d.png";